import { withInstall } from '../../utils';
import Link from './src/link.vue';

export const ILink = withInstall(Link); // 增加类型

export default ILink;
